function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m600 1100c-276.14 0-500-223.86-500-500s223.86-500 500-500 500 223.86 500 500-223.86 500-500 500zm-50-550v300c0 27.613 22.387 50 50 50s50-22.387 50-50v-300l120 90c22.09 16.57 53.43 12.09 70-10s12.09-53.43-10-70l-199.6-149.7c-8.4219-6.4648-18.965-10.305-30.402-10.305s-21.98 3.8398-30.402 10.305l-199.6 149.7c-22.09 16.57-26.57 47.91-10 70s47.91 26.57 70 10z",
  fill: "#474747"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    version: 1.1,
    viewBox: "0 0 1200 1200"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/story-update.aa546054.svg";
export { SvgComponent as ReactComponent };